module.exports = __webpack_public_path__ + "img/icon2.ad9e60ed.png";